<template>
  <div class="jc-recommend" v-show="recommendContend.length">
    <div class="recommend-header">
      <span>新注册用户都在看</span>
    </div>

    <div :class="isMobile ? 'recCardClassMobile' : 'recCardClass'">
      <div
        v-for="(item, index) in recommendContend"
        :key="index"
        :class="[{ 'recommend-card-pc': !isMobile }, 'recommend-card']"
      >
        <div
          class="recommend-cardContent"
          @click="goLink(item.linkUrl)"
          clstag="jdcloud-login|keycount|register|activity"
          :data-qidian-ext="`${JSON.stringify({ cardName: item.clstag, posid: item.clstag })}`"
        >
          <p class="recommend-title">
            {{ item.name }}
          </p>
          <p class="recommend-desc">{{ item.description }}</p>
          <p class="recommend-tag">
            <span>
              {{ item.label }}
            </span>
          </p>
          <div class="recommend-buy">
            <span>{{ item.buttonName }}</span>
            <el-button class="jc-icon-arrow-right recommend-buy-btn" type="text" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { describeOperations } from '@/api/portal-api.js'
// 用户推荐
export default {
  name: 'newUserRecommend',
  props: { clstagType: String },
  data() {
    return {
      recommendContend: []
    }
  },
  created() {
    this.getRecommend()
  },
  methods: {
    // 参数固定写死,position是和底层协商之后,确定的一个字段
    async getRecommend() {
      let {
        result: { result = {} }
      } = await describeOperations({
        pageNum: 1,
        pageSize: 3,
        position: 'registerSuccess',
        status: 0
      })
      this.recommendContend = result.resultList || []
    },
    goLink(link) {
      window.open(link)
    }
  }
}
</script>

<style scoped>
.jc-recommend {
  background: rgba(255, 255, 255, 1);
}
.recommend-header {
  padding: 24px 0 12px 0;
  margin-left: 24px;
  margin-right: 24px;
  border-top: 1px solid #f0f0f0;
}
.recommend-header span {
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
}
.recommend-header a {
  width: 72px;
  height: 22px;
  font-size: 12px;
  font-family: PingFangSC;
  font-weight: normal;
}
.recommend-more {
  width: 72px;
  height: 22px;
  font-size: 12px;
  font-family: PingFangSC;
  font-weight: normal;
  float: right;
}
.recommend-card {
  height: 136px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(0, 0, 0, 0.15);
}
.recommend-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.recCardClass {
  display: flex;
  flex-wrap: wrap;
  padding: 0 24px 8px 24px;
  justify-content: space-between;
}
.recommend-card-pc {
  width: 368px;
  margin: 0 0 18px 0;
}
.recommend-cardContent {
  padding: 16px 0 16px 16px;
  cursor: pointer;
}
.recommend-title {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  font-family: PingFangSC;
  color: rgba(0, 0, 0, 0.85);
  margin-bottom: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.recommend-desc {
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  font-family: PingFangSC;
  color: rgba(0, 0, 0, 0.45);
  margin-bottom: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.recommend-tag {
  margin-bottom: 14px;
}
.recommend-tag span {
  font-size: 12px;
  color: rgba(245, 47, 62, 1);
  border: 1px solid rgba(245, 47, 62, 1);
  border-radius: 2px;
  padding: 0 1px;
}
.recommend-buy {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.65);
}
.recommend-buy-btn {
  color: rgba(0, 0, 0, 0.65);
}
.recommend-card:hover .recommend-buy {
  color: rgba(245, 47, 62, 1);
}
.recommend-card:hover .recommend-buy-btn {
  color: rgba(245, 47, 62, 1);
}

@media only screen and (max-width: 640px) {
  .recommend-header {
    padding: 16px 0 16px 0;
    margin-left: 16px;
    margin-right: 16px;
    border-top: 1px solid #f0f0f0;
  }
  .recCardClassMobile {
    display: flex;
    flex-direction: column;
    padding: 0 16px 16px 16px;
  }
  .recommend-card {
    height: 136px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(0, 0, 0, 0.15);
    margin-bottom: 16px;
  }
}
</style>
